import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { getAuthHttpHeaders } from "../auth";
import Sims from "./Sims";
import { formatDateFromApi, formatDateTimeFromApi } from "../utils/dateTime";

@inject("store")
@observer
class SimGroup extends Component {
  state = {
    simGroup: null,
  };

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  load = async () => {
    const {
      match: {
        params: { simGroupId },
      },
    } = this.props;
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
      });

      let response = await axiosRequest.get("sim/group/" + simGroupId);

      this.setState({ simGroup: response.data });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      store: { zoneId },
      match: {
        params: { simGroupId },
      },
    } = this.props;

    const { simGroup } = this.state;

    if (!simGroup) {
      return <div>Loading SimGroup ${simGroupId}...</div>;
    }

    simGroup.fromDateDisplay = formatDateFromApi(simGroup.fromDate, zoneId);
    simGroup.toDateDisplay = formatDateFromApi(simGroup.toDate, zoneId);

    return (
      <div>
        <h1>
          SimGroup {simGroup.id.substring(0, 4)}: {simGroup.name}, {simGroup.fromDateDisplay} - {simGroup.toDateDisplay},{" "}
          {simGroup.exchange}
        </h1>
        <div>
          <div>Finished at: {formatDateTimeFromApi(simGroup.finishedAt, zoneId)}</div>
          <div>
            Progress:{" "}
            <span
              style={{
                fontFamily: "monospace",
                whiteSpace: "pre",
              }}
            >
              {simGroup.progress}
            </span>
          </div>
        </div>
        <Sims simGroupId={simGroupId} exchangeType={simGroup.exchange} onRefresh={this.load} />
      </div>
    );
  }
}

export default SimGroup;



// WEBPACK FOOTER //
// ./src/sim/SimGroup.js